export const prefixCollection = (
  collection: string,
  prefixString?: string,
  seperator?: string
) => {
  return prefixString
    ? `${prefixString}${seperator ?? "_"}${collection}`
    : collection;
};
